import React from 'react';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  const CART_URL = 'https://pagos.avanzalab.online/checkouts/cn/hWN93DDL9U3kekOUwznOUDsA/es-ar?_r=AQABwkeeujeS07sT7Ib3di0hHptvQRbNe-xmvwPH9xudHaM&cart_link_id=bk0g09nZ&preview_theme_id=185849938234';
  return <section className="py-20 px-4 bg-black text-white text-center" aria-label="Llamado a la acción final" data-id="element-79">
      <div className="max-w-4xl mx-auto" data-id="element-80">
        <h2 className="text-3xl md:text-5xl font-black mb-8 text-white uppercase tracking-tight leading-tight" data-id="element-81">
          Podés seguir buscando tutoriales sueltos.
          <br data-id="element-82" />
          <span className="text-amber-500" data-id="element-83">
            O podés empezar con un sistema.
          </span>
        </h2>

        <div className="space-y-4 text-lg md:text-xl font-medium mb-12 text-gray-300 max-w-2xl mx-auto" data-id="element-84">
          <p data-id="element-85">
            El Mega Pack tiene todo lo que necesitás para aplicar bien, cotizar
            con confianza y cobrar tu primer trabajo.
          </p>
          <p className="text-white font-bold" data-id="element-86">
            Acceso inmediato. Tuyo para siempre.
          </p>
        </div>

        <div className="mb-12" data-id="element-87">
          <p className="text-2xl md:text-3xl font-black text-amber-400 uppercase tracking-wide bg-amber-900/10 inline-block px-8 py-4 rounded-xl border border-amber-900/30" data-id="element-88">
            Tu primer trabajo de epoxi puede estar a semanas de distancia.
          </p>
        </div>

        <a href={CART_URL} className="inline-flex items-center justify-center gap-3 bg-amber-500 hover:bg-amber-400 text-black text-2xl md:text-3xl font-black py-6 px-12 rounded-xl shadow-[0_4px_0_rgb(146,100,10)] hover:shadow-[0_2px_0_rgb(146,100,10)] hover:translate-y-[2px] transition-all w-full md:w-auto" aria-label="Quiero acceder ahora al Mega Pack Pisos Epoxi" data-id="element-89">
          QUIERO ACCEDER AHORA
          <ArrowRight className="w-8 h-8" aria-hidden="true" data-id="element-90" />
        </a>

        <p className="text-gray-500 font-medium mt-6" data-id="element-91">
          $29.990 ARS · Pago único · Acceso inmediato
        </p>
      </div>
    </section>;
}